// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.user-image {\n  /* width: 60%; */\n  height: 45px;\n  padding: 8px;\n  /* padding-right: 25px; */\n  border-radius: 50%;\n  /* margin-top: 5px; */\n}\n\n\n", ""]);
// Exports
module.exports = exports;
